import React from "react"
import styled from "styled-components"
import TitleGroup from './common/TitleGroup'
import UxImg from './images/ux'
import TesteGratis from './teste_gratis'
import Share from './share'

const Wrapper = styled.div`
  padding-top: 50px;  
  padding-bottom: 50px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    @media(max-width: 919px) {
      grid-template-columns: 1fr;
  }
   

  @media(min-width: 1240px) {
    grid-gap: 8rem;
  }
` 
const WrapperContent = styled.div`
    & > div {
    max-width: 583px;
  }
    @media(max-width: 919px) {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`
const Actions = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;

  @media(max-width: 919px) {
    flex-direction: column;
    width: 100%;
  }
  a, div {
    width: 50%;

    @media(max-width: 919px) {
      width: 100%;
    }
  }
`
const Ux = ({ handle }) => (
   <section className="mSection">
            <div className="container" id="usabilidade" data-aos='zoom-out' data-aos-duration="600">
              <Wrapper>
                <div>
                <UxImg />
                </div>
                <WrapperContent>
                  <div>
                  <TitleGroup supTitle="Usabilidade para todos" title="Experiência de uso" icon="far fa-heart">
                    <>
                    <p>Para facilitar o aprendizado, poupar tempo e aumentar sua produção, foi feita a melhoria da jornada de ações similares.<br />Isso significa que as telas seguem o mesmo trajeto de cliques.</p>
                    <p>A TagPlus conta com uma equipe dedicada a escutar os clientes e desenvolver melhorias que tornem o sistema cada vez mais fácil de usar.</p>
                  </>
                  </TitleGroup>
                  </div>
                  
                  <Actions>
                    <TesteGratis />
                    <Share />
                  </Actions>
                  
                </WrapperContent>
                </Wrapper>
            </div>
          </section>
 )
export default Ux
